import styled from 'styled-components'
import { LookButton, buttonLook } from 'components/Buttons/look'

export const Container = styled.div`
  justify-content: center;
  align-items: center;
`

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
`

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 10px;
  gap: 12px;
`

export const AccessLevelBlock = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background-color: #FFFFFF;
  border: ${({ selected }) => selected ? '2px solid #FFC100' : 'none'};
  box-shadow: ${({ selected }) => selected ? 'none' : '0px 2px 10px -6px #252525'};
  border-radius: 10px;
  margin-bottom: 10px;
  padding: 12px 15px;
  gap: 8px;
  cursor: pointer;

  &:hover {
    background-color: #F7F7F7;
  }

  p, div {
    margin: 0px;
    width: auto;
  }
`

export const InfoText = styled.p`
  color: #000000;
  font-size: 14px;
  text-align: center;
  margin-bottom: 0px;
`

export const Title = styled(InfoText)`
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 10px;
`

export const SubTitle = styled(Title)`
  font-size: 14px;
`

export const ButtonText = styled(SubTitle)`
  color: #FFFFFF;
  margin: 0px;
  font-weight: 200;
`

export const Button = styled(LookButton).attrs(buttonLook({ variant: 'secondary' }))`
  width: 160px;
  align-self: center;
  margin: 10px 5px 0px;
`
